import React from 'react'

const UnassignedIcon = () =>
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 14.4948H8V12.5622H15V14.4948ZM18 10.6295H8V8.6969H18V10.6295ZM18 6.76425H8V4.8316H18V6.76425ZM2 4.8316V20.2928H18V22.2254H2C1.46957 22.2254 0.960859 22.0218 0.585786 21.6594C0.210714 21.2969 0 20.8054 0 20.2928V4.8316H2ZM20 0.966309C20.5304 0.966309 21.0391 1.16993 21.4142 1.53237C21.7893 1.89481 22 2.38639 22 2.89896V16.4275C22 17.5001 21.11 18.3601 20 18.3601H6C5.46957 18.3601 4.96086 18.1565 4.58579 17.7941C4.21071 17.4316 4 16.9401 4 16.4275V2.89896C4 1.82634 4.89 0.966309 6 0.966309H20ZM6 2.89896V16.4275H20V2.89896H6Z" fill="white" />
    </svg>

export default UnassignedIcon;



